import { get } from 'lodash';

export const getContactGroups = (state) => get(state, 'contacts.contactGroups', {});